import React from "react";

/**
 * Small localized error boundary. Wrap any single component whose
 * failure should NOT blank the entire page. On error, renders a
 * silent (or fallback) placeholder and logs to console.
 *
 * Usage:
 *   <SafeBoundary fallback={null}>
 *     <MyComponent />
 *   </SafeBoundary>
 */
export default class SafeBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, info) {
        // Log to the browser console so QA can spot it without breaking the page.
        // eslint-disable-next-line no-console
        console.error("SafeBoundary caught:", error, info?.componentStack);
    }
    render() {
        if (this.state.hasError) {
            if (typeof this.props.fallback !== "undefined") return this.props.fallback;
            return null;
        }
        return this.props.children;
    }
}
